
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/marija-najdova-joining",
      function () {
        return require("private-next-pages/blog/marija-najdova-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/marija-najdova-joining"])
      });
    }
  